var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateCustomList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "url(#pattern0_2_15149)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2_15149",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2_15149",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2_15149",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACzUlEQVR4nO2bvW5TMRiGHwnRwNyBHzHRmTsol1AJGLgLysTCjzhbwshNsDFxCQwBARIMsBM1VKISDDATZOEKaJNzbMf5zo/fR/JSuW765NV7bLcBIYQQQgghhBBCiLI4B9wFXgM/gYUGC+/iFbAPjNaVfAX4ILE0heu9d5WcZEkmSnZSsl1dqCaIcnAnRbTrZIkmysE0RfQPiSY2aM5ZNEozSQ4kGpvwSDQSzZBqSolGomk7hUo07YtTddC+VHU0Ek3biVOiaV+SqoMCO1r8QaKNkGgjJNoIiTZCoo2QaCMk2giJLkn0FvAE+ALMgYn/Wsh8y1NcyGvbhJ9sC02WfN8kcr7lmBj7ybbQsmQeRs63HIfGfrItNF/yfQeR8y3HgbGfbAstq4Jx5HzLMTb2k22hLS9vHvEwnLSQ7N4/DEtgIdE2SLQREm3EN+ApsAtsA2eASykLqaPrOU8mJNqIdbd3Q7/r6IToEu46OiG6hLuOTohedsKbR863rpBUbgDv/Cdp3wB7bVfHOHJ+1+86HI9XrHffSnQJdx1Vw9oPLEQPnduBb2SQbIlezVngeS7ZEl2PO3I/C5R9s24hic6XbLcbWYlE/+UecI102bWfEZfo/3cXX9eQ/ZYaJJpTW7g62XWdfUui4/fJscl2h5paSk501dC5oclulFyy6Cpwy9aUbHeoCaJE0VWg5BDZwZQmuoqUnE12SaKrRMlZZJciulpT8vFwh5okShBdZZIctLtYxaLHYwbs9EFyn0XP+iS5r6JnfZPcR9GfgasNv9N14HuGn+XerGwMTfIxI/+X6qMuSGagkv/lxQYkp7yOwVO11cmlsSfJNlxUku247JNd+c4+2vSDT5yuE3VyBBeARxHzR36frSRHsp9QAe5QIyKZduWfzYfMDvDrxMNNsjfAwxXbt5jOFgF8PCF46jvbPSAF+XgJfPIJbro63Ti/Adrs/Ie+YbKPAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateCustomList);
export default __webpack_public_path__ + "static/media/create_custom_list.38850d93bc4062df82761067fa5205e7.svg";
export { ForwardRef as ReactComponent };